import { mapAgendas } from "../utils"

const dayOne = `09:00 - 10:00	Keynote: Thriving in uncertainty
10:15 - 11:00	B1.2 Leveraging risk-based protection to navigate the challenges of digitalisation
11:10 - 11:25	Digital exclusive: Live interview - Attracting and developing talent in Information Security
11:30 - 12:15	B2.5 BlueVoyant: Converging Internal and External Cyber Defence to build resiliency
12:20 - 13:05	Congress back in time: Steve Wozniak in conversation with Steve Durbin
13:30 - 14:15 	B3.4 Untrusted Execution: Attacking the Software Supply Chain
14:30 - 15:15	B4.5 Noetic Cyber: The Over Exposure Problem: New approaches to managing your Attack Surface
15:20 - 15:45	ISF Webinar series: The case for social responsibility in AI: Cyber hot seat
15:45 - 16:45 	Keynote: Quantum Computing: The promise and the threat
16:45 - 17:45	ISF Podcast Live! Solving information security problems`

const dayTwo = `09:00 - 10:00	Keynote: The Never Normal
10:15 - 11:00	B5.4 Welcome home - we've been waiting for you!
11:10 - 11:25	Digital exclusive: Live interview - Women in cyber
11:30 - 12:15	B6.5 Huawei: How your vendor can support you to be ready for NIS2
12:20 - 13:20	Congress back in time: Jamie Bartlett - The Billion-Dollar Crypto Scam
13:30 - 14:15 	B7.3 From guesswork to precision: Tackling the challenges of cyber risk quantification
14:30 - 15:15	B8.5 CrowdStrike: Long live the SOC: A new blueprint for tomorrow’s threats
15:20 - 15:45	ISF Webinar series: CISOs, Warfare and Technology in the Spotlight
15:45 - 16:45 	Keynote: The future of information integrity`

const dayThree = `09:00 - 10:00	Keynote: Changing behaviour: Why facts alone don't work
10:15 - 11:00	B9.1 From media to manager: Making security central to enterprise strategy
11:10 - 11:30	ISF Webinar series: Beyond buzz words - AI, ML and the future of Cyber?
11:30 - 12:15	B10.2 Is product security the next frontier in information security?
12:30 - 13:30	Keynote: Inclusive Leadership`

export default () => {
    const now = new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/London"}))
    const day = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, "0")}-${now.getDate().toString().padStart(2, "0")}`

    const dates = [
        { day: "2023-10-22", sessions: mapAgendas("2023-10-22", dayOne) },
        { day: "2023-10-23", sessions: mapAgendas("2023-10-23", dayTwo) },
        { day: "2023-10-24", sessions: mapAgendas("2023-10-24", dayThree) }
    ]

    return (dates.find(it => it.day === day)?.sessions || dates[0].sessions).map(([start, end, title]) => {
        return 	{
            start,
            end,
            title,
            room: "Auditorium",
            path: "/auditorium",
        }
    })
}